import { useState } from "react";

interface DetailDescriptionProps {
  description: string
}
export const DetailDescription = ({ description }: DetailDescriptionProps) => {
  const [expand, setExpand] = useState<Boolean>(true);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 cursor-pointer" onClick={() => {
          setExpand(!expand);
        }}>
        <div className="">
          <span className="material-icons-outlined mr-2" style={{ verticalAlign: 'bottom', }}>clear_all</span>
          <span className="weight-600">描述</span>
        </div>
        <span className="material-icons-outlined text-gray-400">{expand ? 'expand_less' : 'expand_more'}</span>
      </div>
      <div
        className="bg-gray-50 transition-all duration-700 border-up w-100 txt-14 text-justify overflow-y-auto whitespace-pre-wrap"
        style={{ height: expand ? '200px' : '0px', padding: expand ? '24px' : 0  }}>
        {description}
      </div>
    </>
  )
}